import { Button } from '@Shared/Button/Button';
import type { MenuType } from '@/_types/Shared/SiteDatas';
import type { Decorations } from '@/_types/Shared/Button';

export default function CtaMenu({ CTAMenu, itemClass, icon, deco }: { CTAMenu?: MenuType[]; itemClass: string, icon: boolean, deco: Decorations }) {

	return (
		<div className='py-5'>
			<ul className='flex flex-col gap-8 desktop:flex-row'>
				{CTAMenu?.map((item: MenuType) => {
					return (
						<li key={item.id} className=''>
							<Button
								label={item.title}
								url={item.url}
								style={'primary'}
								urlType={'link'}
								urlOpenNewTab={false}
								btnHasIcon={icon}
								btnDecorationElement={deco}
								primaryClassname= {itemClass}
							/>
						</li>
					);
				})}
			</ul>
		</div>
	);
}